export enum DateFormat {
  DATE = 'dd.MM.yyyy',
  TIME = 'HH:mm',
  DATETIME = 'dd.MM.yyyy HH:mm'
}
